// --------------------------------------------------
// Navigation
// --------------------------------------------------

let cleanupNavigation;

export function navigation(root = document) {
  cleanupNavigation?.();
  const menu = root.querySelector('#side-menu');

  if (!menu) return;

  // --------------------------------------------------
  // Elements
  // --------------------------------------------------

  const panel = menu.querySelector('.side-menu');
  const triggers = root.querySelectorAll('.menu-trigger');
  const closeButtons = menu.querySelectorAll(
    '.side-menu__close, .side-menu-backdrop'
  );
  const menuLinks = menu.querySelectorAll('a');
  const languageButtons = menu.querySelectorAll(
    '.language-switch button'
  );
  const primaryMenuLinks = menu.querySelectorAll(
    '.side-menu__primary a'
  );

  let previousFocus = null;


  // --------------------------------------------------
  // Primary menu labels
  // --------------------------------------------------

  function menuLabels() {
    primaryMenuLinks.forEach((link) => {
      link.dataset.label = link.textContent.trim();
    });
  }

  // --------------------------------------------------
  // Open menu
  // --------------------------------------------------

  function openMenu(trigger) {
    previousFocus = trigger;

    menu.classList.add('is-open');
    menu.setAttribute('aria-hidden', 'false');
    document.body.classList.add('menu-open');

    triggers.forEach((button) => {
      button.setAttribute('aria-expanded', 'true');
    });

    requestAnimationFrame(() => {
      if (menu.classList.contains('is-open')) panel?.focus({ preventScroll: true });
    });
  }

  // --------------------------------------------------
  // Close menu
  // --------------------------------------------------

  function closeMenu() {
    menu.classList.remove('is-open');
    menu.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('menu-open');

    triggers.forEach((button) => {
      button.setAttribute('aria-expanded', 'false');
    });

    previousFocus?.focus();
  }

  // --------------------------------------------------
  // Menu events
  // --------------------------------------------------

  function menuEvents() {
    triggers.forEach((trigger) => {
      trigger.addEventListener('click', () => {
        openMenu(trigger);
      });
    });

    closeButtons.forEach((button) => {
      button.addEventListener('click', closeMenu);
    });

    menuLinks.forEach((link) => {
      link.addEventListener('click', closeMenu);
    });
  }

  // --------------------------------------------------
  // Language switch
  // --------------------------------------------------

  function languageSwitch() {
    languageButtons.forEach((button) => {
      button.addEventListener('click', () => {
        languageButtons.forEach((item) => {
          const isActive = item === button;

          item.classList.toggle('is-active', isActive);
          item.setAttribute('aria-pressed', String(isActive));
        });
      });
    });
  }

  // --------------------------------------------------
  // Focus trap
  // --------------------------------------------------

  function trapFocus(event) {
    if (
      event.key !== 'Tab' ||
      !menu.classList.contains('is-open')
    ) {
      return;
    }

    const focusableElements = [
      ...menu.querySelectorAll(
        'button:not([disabled]):not([tabindex="-1"]), a[href]:not([tabindex="-1"])'
      ),
    ];

    if (!focusableElements.length) return;

    const firstElement = focusableElements[0];
    const lastElement =
      focusableElements[focusableElements.length - 1];

    if (
      event.shiftKey &&
      (document.activeElement === firstElement || document.activeElement === panel)
    ) {
      event.preventDefault();
      lastElement.focus();
      return;
    }

    if (
      !event.shiftKey &&
      document.activeElement === lastElement
    ) {
      event.preventDefault();
      firstElement.focus();
    }
  }

  // --------------------------------------------------
  // Keyboard controls
  // --------------------------------------------------

  function keyboardControls(event) {
    if (!menu.classList.contains('is-open')) return;

    if (event.key === 'Escape') {
      closeMenu();
      return;
    }

    trapFocus(event);
  }

  // --------------------------------------------------
  // Run
  // --------------------------------------------------

  panel?.addEventListener('transitionend', (event) => {
    if (event.target === panel && menu.classList.contains('is-open') &&
        !menu.contains(document.activeElement)) panel.focus({ preventScroll: true });
  });

  menuLabels();
  menuEvents();
  languageSwitch();

  document.addEventListener('keydown', keyboardControls);
  cleanupNavigation = () => {
    document.removeEventListener('keydown', keyboardControls);
    document.body.classList.remove('menu-open');
  };
}